 <template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" name="card1" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                        class="border-0">
                        <template>
                            <div class="text-center mb-4">
                                <h4>문의하기</h4>
                            </div>
                            <form name="sendForm" role="form" method="POST">
                                성명
                                <base-input class="mb-3" name="name" data-vv-as="성명" type="text" placeholder="성명"
                                    v-model="name" addon-left-icon="ni ni-hat-3" v-validate="'required'"
                                    :error="getError('name')">
                                </base-input>
                                이메일 주소
                                <base-input class="mb-3" name="email" type="text" data-vv-as="이메일"
                                    placeholder="daom@naver.com" v-model="email" addon-left-icon="ni ni-email-83"
                                    v-validate="'required|email'" :error="getError('email')">
                                </base-input>
                                연락 받으실 전화번호
                                <base-input name="phonenumber" type="text" data-vv-as="전화번호" placeholder="01022224444"
                                    pattern="01022224444" v-model="phonenumber" addon-left-icon="fa fa-phone"
                                    v-validate="'required|digits:11'" :error="getError('phonenumber')">
                                </base-input>
                                문의 내용
                                <!-- <base-input class="mb-4"> -->
                                <textarea v-model="message" type="text" class="form-control form-control-alternative"
                                    name="message" data-vv-as="문의 내용 " v-validate="'required|min:1'" rows="8" cols="120"
                                    placeholder="문의하실 내용을 작성해주세요." :error="getError('message')">
                                        >
                                    </textarea>
                                <!-- </base-input> -->
                                <div class="text-danger invalid-feedback mt-2 mb-4" style="display: block;">
                                    {{ errors.first('message') }}
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input id="infoChk" class="custom-control-input" type="checkbox" v-model="infoChk" @change="onChk" />
                                    <label for="infoChk" class="custom-control-label">
                                        개인정보 정보 수집에 동의합니다.
                                    </label>
                                </div>
                                <div class="text-danger invalid-feedback mt-2" style="display: block;">
                                    {{ infoChkMsg }}
                                </div>
                                <div id="recaptcha"></div>
                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click.prevent="allChk">문의
                                        접수하기</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <card type="secondary" name="card2" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                        class="border-0" style="display: none;">
                        <template>
                            <div class="text-center mb-4">
                                <h4>감사합니다!</h4>
                                <br>
                                <h4>문의가 접수 되었습니다.</h4>
                            </div>
                            <div style="text-align: center; margin: 20% 0 20% 0;">
                                <i class="fa fa-check-circle" aria-hidden="true" style="font-size: 12em; color:green;"></i>
                            </div>
                            <br>
                            <div>
                                자주 묻는 질문에 대해서 답변을 보고 싶다면 <span style="color:#fb6340; font-weight: bold;">Q&A</span> 를 이용해보세요!<br>
                                <base-button tag="a" href="/qanda" type="warning" class="mt-4">
                                    Q&A 바로가기
                                </base-button>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import KoreanValidate from 'vee-validate/dist/locale/ko'

import ReCaptchaApi from "@/components/recaptcha/api.js";
import Captcha from "@/components/recaptcha/reCaptcha.js";

Validator.localize('ko', KoreanValidate)
Vue.use(VeeValidate, { locale: KoreanValidate })

export default {
    name: "cusotomer",
    components: {
        ReCaptchaApi,
        Captcha
    },
    data() {
        return {
            value: "",
            name: "",
            email: "",
            phonenumber: "",
            message: "",
            infoChk: false,
            infoChkMsg: "",
            sendbtn: false,
            verify: false
        }
    },
    mounted() {

    },
    methods: {
        sendmsg() {
            if(!this.sendbtn){
                Captcha.checkCaptcha({
                    "name" : this.name,
                    "email" : this.email,
                    "phone" : this.phonenumber,
                    "msg" : this.message
                });
            }
            this.sendbtn = true;
        },
        getError(fieldName) {
            if (this.errors.first(fieldName)) {
                return this.errors.first(fieldName)
            }
        },
        //체크박스 체크유무
        onChk() {
            if (!this.infoChk) {
                this.infoChkMsg = "개인정보 수집에 동의해주세요.";
            } else {
                this.infoChkMsg = "";
            }
        },
        //필수사항 체크
        async allChk() {
            let isAllChk = false;
            let isValid = await this.$validator.validateAll();

            this.onChk();

            if (!(isValid & this.infoChk)) {
                return isAllChk;
            }
            
            this.sendmsg();
        }
    }
};

</script>

<style></style>
